<div class="container">
  @if (src) {
    <ngx-extended-pdf-viewer
      #viewer
      class="pdf-viewer"
      [(src)]="src"
      [(formData)]="formData"
      [ignoreKeyboard]="true"
      [textLayer]="preventTextHighlight ? false : true"
      [handTool]="false"
      [spread]="'off'"
      [scrollMode]="0"
      [enableDragAndDrop]="false"
      [contextMenuAllowed]="true"
      [showHandToolButton]="false"
      [showOpenFileButton]="false"
      [showScrollingButtons]="false"
      [showSpreadButton]="false"
      (pagesLoaded)="pdfLoadComplete($event)"
      (textLayerRendered)="afterTextRendered($event)"
      >
    </ngx-extended-pdf-viewer>
  }
</div>
